
import React      from 'react';
import CSSModules from 'react-css-modules';

import FontIcon from '../FontIcon';

import style from './style.scss';

class BreadCrumbs extends React.Component {

    render() {

        return (
            <nav styleName="breadcrumbs-container">

                <ul styleName="breadcrumb-list">
                {
                    this.props.children.map((crumb, index) => {

                        return (
                            <li key={ index }>

                                { crumb }

                                <FontIcon styleName="arrow" iconName="chevron-right" />

                            </li>
                        );
                    })
                }
                </ul>

            </nav>
        );
    }
}

export default CSSModules(BreadCrumbs, style);


// WEBPACK FOOTER //
// ./components/Breadcrumbs/index.js